module.exports = __webpack_public_path__ + "5ffa25ce96dad1a8c4dc82bcc2fd3fba.svg";